import { ResponseError } from '../../errors/responseError';
import { fetchGetTips, TGetTipsResponse } from '../../repositories/text-search/v4/get-tips';
import { IApplicationContext } from '../../types/applicationContext';
import { ITipsV4 } from '../../types/tips';

const DEGRADATION_TELEMETRY_KEY = 'degradation.getTips';

export async function fetchTipsV4(context: IApplicationContext, text: string): Promise<ITipsV4 | null> {
  const { httpApi, logger, telemetry } = context;

  try {
    const { statusCode, response }: TGetTipsResponse = await fetchGetTips({
      httpApi,
      parameters: {
        text,
      },
    });
    if (statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);

      const responseError = new ResponseError({
        domain: 'services.fetchTipsV4',
        message: response.message || '',
        details: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          error: response.errors as any,
        },
      });

      logger.warning(responseError);
      throw responseError;
    }

    return response;
  } catch (ex) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(ex);

    return null;
  }
}
